import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'access-denied',
    loadChildren: () =>
      import('./mx.access-denied/mx.access-denied.module').then(
        (m) => m.MxAccessDeniedModule
      ),
  },
  {
    path: 'destroy-account',
    loadChildren: () =>
      import('./mx.destroy-account/mx.destroy-account.module').then(
        (m) => m.MxDestroyAccountModule
      ),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./mx.error/mx.error.module').then((m) => m.MxErrorModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./mx.forgot-password/mx.forgot-password.module').then(
        (m) => m.MxForgotPasswordModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./mx.login/mx.login.module').then((m) => m.MxLoginModule),
  },
  {
    path: 'not-found',
    loadChildren: () =>
      import('./mx.not-found/mx.not-found.module').then(
        (m) => m.MxNotFoundModule
      ),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./mx.reset-password/mx.reset-password.module').then(
        (m) => m.MxResetPasswordModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MxPagesRoutingModule {}
